module.exports = __webpack_public_path__ + "img/vector-square.16f32db3.svg";